export const ENTITY_KEYS = ['sistemas', 'modulos', 'funcionalidades', 'recursos'];

export const SISTEMAS_CONFIG = {
    sistemas: {key: 'sistemas', title: 'Sistemas', endpoint: '/sistemas', defaultSortBy: 'nome'},
    modulos: {key: 'modulos', title: 'Módulos', endpoint: '/modulos', defaultSortBy: 'nome'},
    funcionalidades: {key: 'funcionalidades', title: 'Funcionalidades', endpoint: '/funcionalidades', defaultSortBy: 'nome'},
    recursos: {key: 'recursos', title: 'Recursos', endpoint: '/recursos', defaultSortBy: 'nome'},
};
